// eslint-disable-next-line import/no-extraneous-dependencies
import { FuroDataNumberInput } from '@furo/data-input/src/furo-data-number-input.js';

export class FormFloat extends FuroDataNumberInput {}

window.customElements.define('form-float', FormFloat);
